module.exports = __webpack_public_path__ + "img/caravan-simple.4f4134ab.svg";